import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, LockKeyhole } from "lucide-react";
import api from "../lib/api";
import { relTime } from "../lib/format";
import TopBar from "../components/TopBar";
import EmptyState from "../components/EmptyState";
import ApprovalActions from "../components/ApprovalActions";

export default function ApprovalsPage() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("pending");

  const load = useCallback(async () => {
    const { data } = await api.get(`/approvals?status=${status}`);
    setItems(data);
  }, [status]);

  useEffect(() => { load(); }, [load]);

  return (
    <>
      <TopBar title="Approval Inbox" subtitle="Only decisions that need a human." />
      <div className="panel">
        <div className="filters">
          <div className="field">
            <label style={{ marginBottom: 3 }}>Status</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="filter-approvals">
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
              <option value="all">All</option>
            </select>
          </div>
          <span className="hint">{items.length} shown</span>
        </div>
        <div className="panel-body">
          {items.length === 0 ? (
            <EmptyState
              title={status === "pending" ? "Nothing waiting on you." : "No records."}
              icon={CheckCircle2}
            />
          ) : (
            items.map((a) => (
              <div className="wide-row" key={a.id} data-testid={`approval-row-${a.id}`}>
                <div>
                  <b><LockKeyhole size={13} style={{ verticalAlign: -2, marginRight: 6 }} />{a.kind.replace(/_/g, " ")}</b>
                  <p>{a.reason || "Approval requested"}</p>
                  <small>
                    Mission <Link to={`/commandlinc/missions/${a.mission_id}`}>{a.mission_id.slice(0, 8)}</Link> · stage {a.stage_key} · requested {relTime(a.requested_at)}
                  </small>
                </div>
                <ApprovalActions approval={a} onDecided={load} />
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
